"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const Box_1 = __importDefault(require("@mui/material/Box"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const styles_1 = require("@mui/material/styles");
const CallSplit_1 = __importDefault(require("@mui/icons-material/CallSplit"));
const utils_1 = require("utils/utils");
const MaterialComboBox_1 = __importDefault(require("./MaterialComboBox"));
const displayTemplate = (componentProps, item, props, inputValue, theme) => {
    const { dataSelected } = props, other = __rest(props, ["dataSelected"]);
    const { menuShowFields } = componentProps;
    const showCat = (menuShowFields || '').includes('category');
    const showAmount = (menuShowFields || '').includes('amount');
    const showPayee = (menuShowFields || 'payee').includes('payee');
    const showTags = (menuShowFields || '').includes('tags');
    const showMemo = (menuShowFields || '').includes('memo');
    // highlight the inputValue
    let str = item.name;
    let strJsx = null;
    if (str) {
        const start = str.indexOf(inputValue);
        if (start >= 0) {
            const strTip = str.slice(0, start);
            const strMid = str.substr(start, inputValue.length);
            const strEnd = str.slice(start + inputValue.length);
            strJsx = (<div>
          {strTip}<b>{strMid}</b>{strEnd}
        </div>);
        }
        else {
            strJsx = (<div>
          {str}
        </div>);
        }
        const miniStyle = {
            fontSize: '11px',
            lineHeight: '11px',
            color: theme.palette.text.input,
        };
        str = (<>
        {showPayee ? strJsx : null}
        {showAmount &&
                <div style={miniStyle}>
            {`Amt: ${item.amountString}`}
          </div>}
        {showCat &&
                <div style={Object.assign(Object.assign({}, miniStyle), { display: 'flex', alignItems: 'center', gap: 4 })}>
            {item.showSplitIcon && (<CallSplit_1.default fontSize="inherit" style={{ fontSize: '14px', alignSelf: 'start' }}/>)}
            <span>{`Cat: ${item.catString}`}</span>
          </div>}
        {showMemo && item.txn &&
                <div style={miniStyle}>
            {`Memo: ${item.txn.memo}`}
          </div>}
        {showTags && item.tagString && item.tagString.length > 0 &&
                <div style={miniStyle}>
            {`Tags: ${item.tagString}`}
          </div>}
      </>);
    }
    return (<ListItem_1.default button {...other} style={{
            // gets rid of highlight in text box
            // backgroundColor: stateColor,
            textAlign: 'left',
        }} key={`autocomplete-item-${item.id}`} dense>
      <ListItemText_1.default style={{ maxWidth: 300, whiteSpace: 'normal', wordBreak: 'break-word', fontWeight: dataSelected ? 600 : 'inherit' }} primary={str}/>
    </ListItem_1.default>);
};
const FilteredInput = (props) => {
    const theme = (0, styles_1.useTheme)();
    const { data, name, disableUnderline, menuPosition, fontSize, onChangeInput, onBlur, placeholder, label, textFieldProps, textFieldVariant, marginProp } = props;
    const [filteredInputState, setFilteredInputState] = (0, react_1.useState)({
        isOpen: false,
        currSel: null,
        listItems: null,
    });
    const prevPropsValue = (0, react_use_1.usePrevious)(props.value);
    const currentValueRef = (0, react_1.useRef)('');
    const onListChange = (changedListItems) => {
        filteredInputState.listItems = changedListItems;
    };
    const handleKeydown = (event) => {
        switch (event.key) {
            // Enter key is for the list to drive a selection of a highlighted item, however, if there is no highlighted
            // item, then Enter should accept the current input (do not stop propogation)
            case 'Enter':
                if (filteredInputState.isOpen && (0, utils_1.exists)(filteredInputState.currSel) && filteredInputState.listItems) {
                    event.stopPropagation();
                }
                break;
            case 'Escape':
                if (filteredInputState.isOpen) {
                    event.stopPropagation();
                }
                break;
            case 'Tab':
                if (filteredInputState.isOpen) {
                    if (props.onChange && (0, utils_1.exists)(filteredInputState.currSel) && filteredInputState.listItems) {
                        props.onChange(filteredInputState.listItems.get(filteredInputState.currSel));
                    }
                }
                else if (currentValueRef.current) {
                    props.onChange({ action: 'Tab', name: currentValueRef.current });
                }
                break;
            default:
                break;
        }
    };
    (0, react_1.useEffect)(() => {
        if (props.value !== prevPropsValue) {
            currentValueRef.current = props.value;
        }
    }, [props.value, prevPropsValue]);
    return (<Box_1.default component="div" sx={{ flex: 2, overflow: 'hidden' }} 
    // @ts-expect-error - FIXME: some event type issue
    onKeyDown={handleKeydown}>
      <div>
        <MaterialComboBox_1.default 
    // this is used for setting the name property of the input field
    name={name} 
    // This is the list of data that is databound to the combobox
    items={data} inputRef={props.inputRef} value={props.value} disableUnderline={disableUnderline} menuPosition={menuPosition} textFieldProps={textFieldProps} 
    // This is a template that can be overridden for each list item
    displayTemplate={(item, filteredInputProps, inputValue) => displayTemplate(props, item, filteredInputProps, inputValue, theme)} 
    // This is placeholder text when the input has focus
    placeholder={placeholder || 'Payee Name'} label={label} fontSize={fontSize} textFieldVariant={textFieldVariant} marginProp={marginProp} 
    // This affects the search behavior
    // Maybe what you search is different from just
    // one single prop.
    // so this is how one might search across many properties
    searchTemplate={(item) => `${item.name}`} 
    // Currently a noop, but you can fire an event
    // as a side effect each time the input changes
    onChangeInput={(e) => {
            // @ts-expect-error TS(2339) - FIXME: Property 'value' does not exist on type 'EventTarget'
            currentValueRef.current = e.target.value;
            onChangeInput(e);
        }} onBlur={onBlur} 
    // This controls what you see in the actual input
    // when an item is selected
    inputDisplayTemplate={(selectedItem) => `${selectedItem ? selectedItem.name : ''}`} onListChange={onListChange} initialHighlightedIndex={0} 
    // This event fires every time there are state changes inside the Combobox
    // @ts-expect-error - FIXME: type issue with DownShift when adding this as a prop type in MaterialCombobox.
    onStateChange={({ highlightedIndex, isOpen, }) => {
            // NOTE, material combobox does not accurately tell us when the list
            // closes if it closes due to there being no matches.  So we proxy that here
            // by setting isOpen to reflect whether the current list being rendered has any
            // items at all (in the cases where isOpen is undefined
            //
            if (isOpen !== undefined) {
                setFilteredInputState((prevState) => (Object.assign(Object.assign({}, prevState), { isOpen: Boolean(isOpen) })));
            }
            else {
                setFilteredInputState((prevState) => (Object.assign(Object.assign({}, prevState), { isOpen: Boolean(filteredInputState.listItems && filteredInputState.listItems.size > 0) })));
            }
            setFilteredInputState((prevState) => (Object.assign(Object.assign({}, prevState), { currSel: highlightedIndex })));
        }} 
    // This (very important) event fires everytime a new item in the combobox
    // Is selected
    onChange={(item) => {
            if (item && props.onChange) {
                props.onChange(item);
            }
        }} width={props.width}/>
      </div>
    </Box_1.default>);
};
exports.default = FilteredInput;
